import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import BaseLink from '@/components_new/BaseLink.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { ROUTE_NAMES } from '@/router/constants'
import { BLOG_PATH, DEVELOPERS_LANDPAGE_PATH, NavLink, PARTNERS_LANDPAGE_PATH } from '@/router/navigation-constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderTiles',
  setup(__props) {

const tr = useTr()

const allItems = computed((): NavLink[] => [
    {
        title: tr('tiles.add_games'),
        externalTo: DEVELOPERS_LANDPAGE_PATH,
        target: '_blank',
    },
    {
        title: tr('tiles.publishers'),
        externalTo: PARTNERS_LANDPAGE_PATH,
        target: '_blank',
    },
    {
        title: tr('tiles.contacts'),
        to: { name: ROUTE_NAMES.CONTACTS },
    },
    {
        title: tr('navigation.blog'),
        externalTo: BLOG_PATH,
        target: '_blank',
    },
])

const popupRef = ref<HTMLElement | null>(null)
const buttonRef = ref<HTMLElement | null>(null)
const showMore = ref(false)
const hasRestItems = computed(() => allItems.value.length > 4)

function toggleShow(forceHide?: boolean) {
    if (forceHide === false) {
        showMore.value = false
        return
    }
    showMore.value = !showMore.value
}

function toggleMore(e: MouseEvent) {
    buttonRef.value = e.currentTarget as HTMLElement
    toggleShow()
}

function onClickOutside(event: MouseEvent) {
    if (!showMore.value) {
        return
    }
    const target = event.target as Node

    const clickedOutsidePopup = !popupRef.value?.contains(target)
    const clickedOutsideButton = !buttonRef.value?.contains(target)

    if (clickedOutsidePopup && clickedOutsideButton) {
        toggleShow(false)
    }
}

onMounted(() => {
    document.addEventListener('click', onClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', onClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.tiles_wrapper)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.tiles_button, _ctx.$style.tabletPlus])
    }, [
      _createElementVNode("button", {
        "data-interface-target": "open-links-menu",
        class: _normalizeClass(_ctx.$style.icon_wrapper),
        onClick: toggleMore
      }, [
        _createVNode(Icon, {
          name: "plus",
          class: _normalizeClass([_ctx.$style.icon, showMore.value && _ctx.$style.icon_rotate])
        }, null, 8, ["class"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([
                _ctx.$style.tiles_row,
                _ctx.$style.desktop,
                hasRestItems.value && !showMore.value && _ctx.$style.reduced_tiles,
                hasRestItems.value && showMore.value && _ctx.$style.reduced_tiles_opened,
            ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allItems.value, (item, index) => {
        return (_openBlock(), _createBlock(BaseLink, {
          key: index,
          to: item.to,
          externalTo: item.externalTo,
          target: item.target,
          class: _normalizeClass(_ctx.$style.tile)
        }, {
          default: _withCtx(() => [
            _createVNode(Typography, {
              type: "caption_all-caps",
              semibold: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["to", "externalTo", "target", "class"]))
      }), 128)),
      _createElementVNode("button", {
        class: _normalizeClass([_ctx.$style.tile, _ctx.$style.more_btn, !showMore.value && hasRestItems.value && _ctx.$style.more_btn_visible]),
        onClick: toggleMore
      }, [
        _createVNode(Typography, {
          type: "caption_all-caps",
          semibold: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('tiles.more')), 1)
          ]),
          _: 1
        })
      ], 2)
    ], 2),
    _createElementVNode("div", {
      ref_key: "popupRef",
      ref: popupRef,
      class: _normalizeClass(_ctx.$style.popup)
    }, [
      _createVNode(_TransitionGroup, {
        tag: "div",
        class: _normalizeClass(_ctx.$style.tiles_popup),
        enterActiveClass: _ctx.$style.fade_enter_active,
        leaveToClass: _ctx.$style.fade_leave_to
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showMore.value ? allItems.value : [], (item, index) => {
            return (_openBlock(), _createBlock(BaseLink, {
              key: index,
              to: item.to,
              externalTo: item.externalTo,
              target: item.target,
              class: _normalizeClass(_ctx.$style.tile)
            }, {
              default: _withCtx(() => [
                _createVNode(Typography, {
                  type: "caption_all-caps",
                  semibold: "",
                  class: _normalizeClass(_ctx.$style.desktop)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createVNode(Typography, {
                  type: "header",
                  size: "xs",
                  semibold: "",
                  class: _normalizeClass(_ctx.$style.tabletPlus)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["to", "externalTo", "target", "class"]))
          }), 128)),
          _createElementVNode("button", {
            key: "close-btn",
            class: _normalizeClass([_ctx.$style.tile, _ctx.$style.close_btn, _ctx.$style.desktop]),
            onClick: toggleMore
          }, [
            _createVNode(Typography, {
              type: "caption_all-caps",
              accent: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tr('tiles.close')), 1)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "enterActiveClass", "leaveToClass"])
    ], 2)
  ], 2))
}
}

})